import styled from 'styled-components';

import trunkIcon from '~/assets/icons/trunk.svg';

const StyledContainer = styled.div`
	position: relative;
	height: 20px;
	display: flex;
	align-items: center;
	gap: 0;
	font-family: 'GT Walsheim Pro';
	font-size: 16px;
	font-weight: bold;
	line-height: 18px;
	color: #fff;
	transition: color 0.25s ease;

	span:first-child {
		text-indent: 30px;
	}

	span:last-child {
		font-weight: normal;
		opacity: 0.5;
	}

	&::before {
		content: '';
		position: absolute;
		width: 20px;
		height: 20px;
		mask-image: url(${trunkIcon});
		mask-position: center;
		mask-repeat: no-repeat;
		-webkit-mask-image: url(${trunkIcon});
		-webkit-mask-position: center;
		-webkit-mask-repeat: no-repeat;
		background-color: #fff;
		transition: background-color 0.25s ease;
	}
`;

export { StyledContainer };
